import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Notification, RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankHeightSelect = ({
  typeKey,
  dataField,
  setDataField,
  fieldOptions,
  error
}) => {
  const {
    iotOrderDetailsSection: {
      nssFarmAndRanchTankDetailsLabel: { tankHeight }
    },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldHasError = error && !dataField.valueTankProduct;

  const getFieldOptionNote = option => {
    if (option === '15 sensor <15m') return '(only available in gasoline)';
    return '';
  };

  useEffect(() => {
    if (fieldOptions.length === 1) {
      setDataField({
        ...dataField,
        valueTankProduct: fieldOptions[1]
      });
    }
  }, []);

  const radioItems = fieldOptions.map(option => ({
    label: `${option} ${getFieldOptionNote(option)}`,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankHeight}
        items={radioItems}
        checkedId={dataField.valueTankHeight || (fieldOptions.length === 1 ? fieldOptions[0] : null)}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankHeight: value
        })}
        name={`${typeKey}--tank-height`}
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      {dataField.valueTankHeight === 'Other' && (
        <input
          type="text"
          className={`tank-details__other-product ${fieldHasError && 'error'}`}
          placeholder="height.."
          value={dataField.valueTankHeightOther}
          onChange={e =>
            setDataField({
              ...dataField,
              valueTankHeightOther: e.target.value
            })
          }
        />
      )}
      <Notification variant={{ style: 'subtle' }}>
        Note: If customer needs sensor length greater than 10m (32 ft) in diesel
        application, the Fuel Sensor 15 will need to be selected
      </Notification>
      {fieldHasError && (
        <div style={{ marginTop: '5px' }}>
          <Notification variant={{ validation: 'error' }}>
            {fieldRequiredMessage}
          </Notification>
        </div>
      )}
      <Spacer space={2} />
    </>
  );
};

TankHeightSelect.propTypes = {
  typeKey: PropTypes.string.isRequired,
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankHeightOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  fieldOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  error: PropTypes.string.isRequired
};

export default TankHeightSelect;
